export default "__VITE_ASSET__D8ung67___"